import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class ToolBar extends React.Component {
  static propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
    padding: PropTypes.oneOf(['none', 'xs', 'sm', 'md', 'lg', 'xl']),
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    component: 'div',
    align: 'left',
    padding: 'sm',
    className: undefined,
    children: null,
  };

  renderWrappedChild = child => {
    const { padding } = this.props;
    const wrapperClasses = clx('wrapper', {
      [`padding-${padding}`]: padding && padding !== 'none',
    });

    return [<div className={wrapperClasses}>{child}</div>, ' '];
  };

  render() {
    const { component: ToolBarComponent, className, align, children } = this.props;

    const toolbarClasses = clx(className, {
      [`align-${align}`]: align,
    });

    return (
      <ToolBarComponent className={toolbarClasses}>
        {React.Children.map(children, this.renderWrappedChild)}
      </ToolBarComponent>
    );
  }
}
